// src/components/common/CategoryFilterSkeleton.tsx
import React from 'react';

export function CategoryFilterSkeleton() {
    return (
        // O contêiner principal tem a mesma forma do filtro real, mas com um fundo cinza.
        <div className="relative overflow-hidden bg-gray-200 rounded-xl px-4 py-3">
            {/* Barra cinza para simular o texto do filtro */}
            <div className="h-5 w-20 bg-gray-300 rounded"></div>

            {/* Overlay com a animação de brilho (shimmer) que já definimos no tailwind.config.js */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent animate-shimmer"></div>
        </div>
    );
}